/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import "moment/locale/th";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Avatar from "@material-ui/core/Avatar";
import Hidden from "@material-ui/core/Hidden";
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/lab
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineOppositeContent from "@material-ui/lab/TimelineOppositeContent";
import TimelineDot from "@material-ui/lab/TimelineDot";

// Core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";
import TSSelect2 from "components/Forms/TSSelect2";
import TSText from "components/Forms/TSText";

// Reactstrap
import { Input, Label, FormGroup, Modal, ModalBody } from "reactstrap";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

const useStyles = makeStyles((theme) => ({
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none",
  },
  paper: {
    padding: "8px 16px",
  },
  largeAvatar: {
    width: theme.spacing(6),
    height: theme.spacing(6),
  },
  radioGroup: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
    marginTop: "8px",
    marginBottom: "12px",
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "15px",
  },
}));

const Request = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const params = useParams();

  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const isHR =
    currentUser?.userDepartment?.some(
      (u) =>
        u.departmentKey === 105 ||
        u.departmentKey === 108 ||
        (u.departmentKey === 143 && u.userLevelKey === 3)
    ) || currentUser?.userName === "madarakung";

  // URL ID Path Params / Query / Location State
  const requestIdFromParams = params?.id || props?.match?.params?.id;
  const queryParams = new URLSearchParams(location.search);
  const requestIdFromUrl = queryParams.get("id");
  const requestIdFromState = location.state?.id || location.state?.timeAttendanceRequestID;
  const targetRequestId = requestIdFromParams || requestIdFromUrl || requestIdFromState || null;
  const isEdit = Boolean(targetRequestId);

  // Form States
  const [TimeAttendanceRequestID, setTimeAttendanceRequestID] = useState(targetRequestId || "");
  const [WorkDate, setWorkDate] = useState(moment().format("YYYY-MM-DD"));
  const [AttendanceType, setAttendanceType] = useState(1); // 1 = เช้า, 2 = เย็น, 3 = ทั้งเข้าและออก, 10 = ขอตามโควต้า
  const [CheckInTime, setCheckInTime] = useState("08:30");
  const [CheckOutTime, setCheckOutTime] = useState("16:30");
  const [DurationHours, setDurationHours] = useState(0);
  const [Reason, setReason] = useState("");
  const [WitnessUserName, setWitnessUserName] = useState("");
  const [DepartmentBossUserName, setDepartmentBossUserName] = useState("");
  const [GroupWorkBossUserName, setGroupWorkBossUserName] = useState("");
  const [MissionBossUserName, setMissionBossUserName] = useState("");
  const [BossUserName, setBossUserName] = useState("");
  const [HRUserName, setHRUserName] = useState("");

  // Categories & Quota States
  const [categories, setCategories] = useState([]);
  const [selectedCategoryID, setSelectedCategoryID] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [quotaPeriod, setQuotaPeriod] = useState("morning"); // "morning" | "afternoon"
  const [quotaInfo, setQuotaInfo] = useState(null);
  const [loadingQuota, setLoadingQuota] = useState(false);

  // Approvals & Tracking
  const [Approvals, setApprovals] = useState([]);
  const [RequestStatusKey, setRequestStatusKey] = useState(0);
  const [IsApprove, setIsApprove] = useState(null);
  const [IsCancel, setIsCancel] = useState(false);
  const [RequesterName, setRequesterName] = useState("");
  const [RequesterInfo, setRequesterInfo] = useState("");

  // Dropdown Lists & Hierarchy Levels
  const [witnessList, setWitnessList] = useState([]);
  const [bossList, setBossList] = useState([]);
  const [requesterUserLevel, setRequesterUserLevel] = useState(1);
  const [departmentBossList, setDepartmentBossList] = useState([]);
  const [groupWorkBossList, setGroupWorkBossList] = useState([]);
  const [missionBossList, setMissionBossList] = useState([]);

  // Modals & UI States
  const [modalConfirm, setModalConfirm] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [modalCancel, setModalCancel] = useState(false);
  const [modalApprove, setModalApprove] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [icon, setIcon] = useState("far fa-question-circle");

  // Approve Action states
  const [selectedApproveKey, setSelectedApproveKey] = useState(null);
  const [actionIsApprove, setActionIsApprove] = useState(true);
  const [approveDescription, setApproveDescription] = useState("รับรอง/เห็นควรอนุญาต");

  // กรองตัวเลือกไม่ให้ซ้ำกันตาม username (value)
  const filterUnique = (arr) => {
    const seen = new Set();
    return arr.filter((item) => {
      const k = item.value?.toLowerCase();
      if (!k || seen.has(k)) return false;
      seen.add(k);
      return true;
    });
  };

  // ดึงข้อมูล MyTeam แบบเดียวกับระบบลา (Leave/Request.js)
  const loadMyTeam = (targetUser = null) => {
    axios
      .post("/api/v1/myteam", {
        userName: targetUser || "",
        leaveRequestID: "00000000-0000-0000-0000-000000000000",
      })
      .then(
        (result) => {
          if (result.data?.data) {
            const json = result.data.data;
            const myteam = json.map((o) => ({
              ...o,
              value: o.userName.toLowerCase(),
              label: `${o.userProfile?.firstName || ""} ${o.userProfile?.lastName || ""}${
                o.userProfile?.nickName ? ` (${o.userProfile.nickName})` : ""
              }`,
            }));

            const resUserName = (result.data.userName || targetUser || currentUser?.userName || "").toLowerCase();
            const jsonMy =
              myteam.find((e) => e.userName?.toLowerCase() === resUserName && e.isDefault) ||
              myteam.find((e) => e.userName?.toLowerCase() === resUserName) ||
              { userLevelKey: 0 };

            const myLevel = jsonMy.userLevelKey ?? 0;
            setRequesterUserLevel(myLevel === 0 ? 1 : myLevel + 1);

            // 1. ผู้รับงานแทน เปรียบเสมือน WitnessUserName
            const jsonStanin = myteam.filter(
              (e) => e.userName?.toLowerCase() !== resUserName && e.userLevelKey < 3
            );
            setWitnessList(filterUnique(jsonStanin));

            // 2. หัวหน้างาน (แสดงเฉพาะเมื่อ userLevelKey < 1)
            const jsonDept = myteam.filter(
              (e) => e.userName?.toLowerCase() !== resUserName && e.userLevelKey === 1 && myLevel < 1
            );
            setDepartmentBossList(filterUnique(jsonDept));

            // 3. หัวหน้ากลุ่มงาน (แสดงเฉพาะเมื่อ userLevelKey < 2)
            const jsonGroup = myteam.filter(
              (e) =>
                e.userName?.toLowerCase() !== resUserName &&
                e.userLevelKey === 2 &&
                (e.isDefault || e.isDefault == null) &&
                myLevel < 2
            );
            setGroupWorkBossList(filterUnique(jsonGroup));

            // 4. รองภารกิจ (แสดงเฉพาะเมื่อ userLevelKey < 3)
            const jsonMission = myteam.filter(
              (e) =>
                e.userName?.toLowerCase() !== resUserName &&
                (e.userLevelKey === 2 || e.userLevelKey === 3) &&
                myLevel < 3
            );
            setMissionBossList(filterUnique(jsonMission));
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  // คำนวณ userLevel ของผู้ขอ: 1=ผู้ปฏิบัติงาน, 2=หัวหน้างาน, 3=หัวหน้ากลุ่มงาน, 4=หัวหน้าภารกิจ/ผอ.
  const curDefaultDept = currentUser?.userDepartment?.find((d) => d.isDefault) || currentUser?.userDepartment?.[0];
  const curLevelKey = curDefaultDept?.userLevelKey ?? 0;
  const fallbackLevel = curLevelKey === 0 ? 1 : (curLevelKey === 1 ? 2 : (curLevelKey === 2 ? 3 : 4));
  const activeUserLevel = requesterUserLevel || fallbackLevel;

  const showDeptBoss = activeUserLevel === 1;
  const showGroupBoss = activeUserLevel === 1 || activeUserLevel === 2;
  const showMissionBoss = activeUserLevel === 1 || activeUserLevel === 2 || activeUserLevel === 3;

  const calculateDuration = (startTime, endTime) => {
    if (!startTime || !endTime) return 0;
    const start = moment(`2000-01-01 ${startTime}`, "YYYY-MM-DD HH:mm");
    const end = moment(`2000-01-01 ${endTime}`, "YYYY-MM-DD HH:mm");
    let diff = end.diff(start, "hours", true);
    return diff > 0 ? parseFloat(diff.toFixed(2)) : 0;
  };

  const loadQuota = (catId, targetDate, reqId = null, targetUser = null) => {
    if (!catId) return;
    setLoadingQuota(true);
    const qParams = {
      categoryId: catId,
      date: targetDate ? moment(targetDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
    };
    if (reqId) qParams.requestId = reqId;
    if (targetUser) qParams.empCode = targetUser;

    axios
      .get("/api/v1/timeattendance/quota", { params: qParams })
      .then((res) => {
        if (res.data?.result === 200) {
          setQuotaInfo(res.data.data);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoadingQuota(false));
  };

  const handlePeriodChange = (newPeriod, currentCategory = selectedCategory) => {
    setQuotaPeriod(newPeriod);
    const maxH = currentCategory?.maxHoursPerRequest || 2;
    const cIn = newPeriod === "afternoon" ? "13:00" : "08:00";
    const cOut = moment(`2000-01-01 ${cIn}`, "YYYY-MM-DD HH:mm").add(maxH, "hours").format("HH:mm");
    setCheckInTime(cIn);
    setCheckOutTime(cOut);
    setDurationHours(calculateDuration(cIn, cOut));
  };

  const handleCategoryChange = (catId) => {
    setSelectedCategoryID(catId);
    const found = categories.find((c) => c.categoryID === catId);
    setSelectedCategory(found || null);
    if (found) {
      setAttendanceType(found.categoryMode);
      if (found.isDisableLv1) {
        setWitnessUserName("");
      }
      if (found.categoryMode === 10) {
        const canM = found.allowMorning !== false;
        const canA = found.allowAfternoon !== false;
        let chosenPeriod = "morning";
        if (!canM && canA) {
          chosenPeriod = "afternoon";
        } else {
          chosenPeriod = "morning";
        }
        handlePeriodChange(chosenPeriod, found);
        loadQuota(found.categoryID, WorkDate, TimeAttendanceRequestID);
      } else {
        setQuotaInfo(null);
      }
    }
  };

  const handleWorkDateChange = (date) => {
    if (moment.isMoment(date)) {
      const dStr = date.format("YYYY-MM-DD");
      setWorkDate(dStr);
      if (selectedCategoryID && (selectedCategory?.categoryMode === 10 || AttendanceType === 10)) {
        loadQuota(selectedCategoryID, dStr, TimeAttendanceRequestID);
      }
    }
  };

  useEffect(() => {
    // 0. โหลดหมวดหมู่การลงเวลา
    axios
      .get("/api/v1/timeattendance/categories")
      .then((res) => {
        if (res.data?.data) {
          setCategories(res.data.data);
          if (!targetRequestId && res.data.data.length > 0) {
            const first = res.data.data[0];
            setSelectedCategoryID(first.categoryID);
            setSelectedCategory(first);
            setAttendanceType(first.categoryMode);
            if (first.isDisableLv1) {
              setWitnessUserName("");
            }
            if (first.categoryMode === 10) {
              const canM = first.allowMorning !== false;
              const canA = first.allowAfternoon !== false;
              let chosenPeriod = "morning";
              if (!canM && canA) {
                chosenPeriod = "afternoon";
              } else {
                chosenPeriod = "morning";
              }
              handlePeriodChange(chosenPeriod, first);
              loadQuota(first.categoryID, WorkDate);
            }
          }
        }
      })
      .catch((err) => console.log(err));

    // 1. โหลดข้อมูลทีมและสายการอนุมัติผ่าน /api/v1/myteam แบบเดียวกับระบบลา (Leave/Request.js)
    if (!targetRequestId) {
      loadMyTeam();
    }

    // 2. หากมี targetRequestId ให้ดึงข้อมูลมาแสดง (โหมดดู/อนุมัติ/แก้ไข)
    if (targetRequestId) {
      axios
        .get(`/api/v1/timeattendance/${targetRequestId}`)
        .then((res) => {
          const d = res.data?.data;
          if (d) {
            // โหลด MyTeam ของผู้ขอคำขอ
            loadMyTeam(d.userName);
            setTimeAttendanceRequestID(d.timeAttendanceRequestID);
            const targetDate = d.checkInDT || d.checkOutDT;
            if (targetDate) {
              setWorkDate(moment(targetDate).format("YYYY-MM-DD"));
            }
            setAttendanceType(d.attendanceType);

            if (d.categoryID) {
              setSelectedCategoryID(d.categoryID);
            }
            if (d.category) {
              setSelectedCategory(d.category);
              if (d.category.categoryMode === 10) {
                loadQuota(d.categoryID, d.workDate, d.timeAttendanceRequestID, d.userName);
              }
            } else if (d.attendanceType === 10) {
              loadQuota(d.categoryID, d.workDate, d.timeAttendanceRequestID, d.userName);
            }

            if (d.durationHours != null) {
              setDurationHours(d.durationHours);
            }

            if (d.checkInDT) {
              const inMoment = moment(d.checkInDT);
              setCheckInTime(inMoment.format("HH:mm"));
              if (inMoment.hour() >= 13) {
                setQuotaPeriod("afternoon");
              } else {
                setQuotaPeriod("morning");
              }
            }
            if (d.checkOutDT) {
              setCheckOutTime(moment(d.checkOutDT).format("HH:mm"));
            }

            if (d.category && d.category.categoryMode === 10 && (d.durationHours == null || d.durationHours === 0)) {
              if (d.checkInDT && d.checkOutDT) {
                const dur = calculateDuration(moment(d.checkInDT).format("HH:mm"), moment(d.checkOutDT).format("HH:mm"));
                setDurationHours(dur);
              }
            }

            setReason(d.reason || "");
            
            if (d.witnessUserName) {
              const wName = d.witnessUserName.toLowerCase();
              setWitnessUserName(wName);
              if (d.witnessUser) {
                setWitnessList((prev) => {
                  const exists = prev.some((x) => x.value?.toLowerCase() === wName);
                  if (!exists) {
                    return [
                      ...prev,
                      {
                        value: wName,
                        label: `${d.witnessUser.firstName} ${d.witnessUser.lastName}` + (d.witnessUser.nickName ? ` (${d.witnessUser.nickName})` : ""),
                      },
                    ];
                  }
                  return prev;
                });
              }
            } else {
              setWitnessUserName("");
            }

            if (d.departmentBossUserName) {
              const dbName = d.departmentBossUserName.toLowerCase();
              setDepartmentBossUserName(dbName);
              if (d.departmentBossUser) {
                setDepartmentBossList((prev) => {
                  const exists = prev.some((x) => x.value?.toLowerCase() === dbName);
                  if (!exists) {
                    return [
                      ...prev,
                      {
                        value: dbName,
                        label: `${d.departmentBossUser.firstName} ${d.departmentBossUser.lastName}` + (d.departmentBossUser.nickName ? ` (${d.departmentBossUser.nickName})` : "") + " (หัวหน้างาน)",
                      },
                    ];
                  }
                  return prev;
                });
              }
            } else {
              setDepartmentBossUserName("");
            }

            if (d.groupWorkBossUserName) {
              const gbName = d.groupWorkBossUserName.toLowerCase();
              setGroupWorkBossUserName(gbName);
              if (d.groupWorkBossUser) {
                setGroupWorkBossList((prev) => {
                  const exists = prev.some((x) => x.value?.toLowerCase() === gbName);
                  if (!exists) {
                    return [
                      ...prev,
                      {
                        value: gbName,
                        label: `${d.groupWorkBossUser.firstName} ${d.groupWorkBossUser.lastName}` + (d.groupWorkBossUser.nickName ? ` (${d.groupWorkBossUser.nickName})` : "") + " (หัวหน้ากลุ่มงาน)",
                      },
                    ];
                  }
                  return prev;
                });
              }
            } else {
              setGroupWorkBossUserName("");
            }

            if (d.missionBossUserName) {
              const mbName = d.missionBossUserName.toLowerCase();
              setMissionBossUserName(mbName);
              if (d.missionBossUser) {
                setMissionBossList((prev) => {
                  const exists = prev.some((x) => x.value?.toLowerCase() === mbName);
                  if (!exists) {
                    return [
                      ...prev,
                      {
                        value: mbName,
                        label: `${d.missionBossUser.firstName} ${d.missionBossUser.lastName}` + (d.missionBossUser.nickName ? ` (${d.missionBossUser.nickName})` : "") + " (รองภารกิจ)",
                      },
                    ];
                  }
                  return prev;
                });
              }
            } else {
              setMissionBossUserName("");
            }

            if (d.bossUserName) {
              const bName = d.bossUserName.toLowerCase();
              setBossUserName(bName);
              if (d.bossUser) {
                setBossList((prev) => {
                  const exists = prev.some((x) => x.value?.toLowerCase() === bName);
                  if (!exists) {
                    return [
                      ...prev,
                      {
                        value: bName,
                        label: `${d.bossUser.firstName} ${d.bossUser.lastName}` + (d.bossUser.nickName ? ` (${d.bossUser.nickName})` : ""),
                      },
                    ];
                  }
                  return prev;
                });
              }
            } else {
              setBossUserName("");
            }

            setHRUserName(d.hrUserName || "");
            setApprovals(d.approvals || []);
            setRequestStatusKey(d.requestStatusKey);
            setIsApprove(d.isApprove);
            setIsCancel(Boolean(d.isCancel));

            if (d.requesterUser) {
              const u = d.requesterUser;
              setRequesterName(`${u.titleName || ""}${u.firstName} ${u.lastName}`);
              const dep = u.userDepartment?.find((x) => x.isDefault);
              const depName = dep?.department?.name || "";
              const groupName = dep?.department?.groupWork?.name || "";
              setRequesterInfo(
                `${u.positionName || ""} ${depName} ${groupName} (${u.typeGov?.name || ""})`
              );
            }
          }
        })
        .catch((err) => console.log(err));
    }
  }, [targetRequestId]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = [];

    if (!WorkDate) errors.push("กรุณาระบุวันที่มาปฏิบัติงาน");
    if (!selectedCategoryID) errors.push("กรุณาเลือกประเภทการลงเวลา");
    if (!Reason.trim()) errors.push("กรุณาระบุเหตุผล / วัตถุประสงค์");

    const isDisableLv1 = Boolean(selectedCategory?.isDisableLv1);
    if (!isDisableLv1 && !WitnessUserName) {
      const lv1Label = selectedCategory?.lv1Text || "พยาน (เจ้าหน้าที่ร่วมรับรอง)";
      errors.push(`กรุณาระบุ${lv1Label}`);
    }

    // ตรวจสอบสายการอนุมัติแบบเดียวกับระบบลา (Leave/Request.js)
    if (missionBossList.length > 0 && !MissionBossUserName) {
      errors.push("กรุณาระบุรองภารกิจ");
    } else if (activeUserLevel < 4 && !DepartmentBossUserName && !GroupWorkBossUserName && !MissionBossUserName && !BossUserName) {
      errors.push("กรุณาเลือกผู้อนุมัติอย่างน้อย 1 ท่าน");
    }

    if (selectedCategory?.categoryMode === 10) {
      if (DurationHours <= 0) {
        errors.push("กรุณาระบุช่วงเวลาให้ถูกต้อง (เวลาสิ้นสุดต้องมากกว่าเวลาเริ่มต้น)");
      }
      if (selectedCategory.maxHoursPerRequest && DurationHours > selectedCategory.maxHoursPerRequest) {
        errors.push(`จำนวนชั่วโมงที่ขอ (${DurationHours} ชม.) เกินสิทธิ์สูงสุดที่กำหนด (${selectedCategory.maxHoursPerRequest} ชม./ครั้ง)`);
      }
      if (quotaInfo && quotaInfo.quotaLimitType > 0 && quotaInfo.remainingQuota <= 0) {
        errors.push(`คุณใช้โควต้าสำหรับ '${selectedCategory.categoryName}' เต็มแล้วในรอบนี้`);
      }

      // ตรวจสอบความถูกต้องของช่วงเวลา
      const canMorning = selectedCategory.allowMorning !== false;
      const canAfternoon = selectedCategory.allowAfternoon !== false;
      const currentPeriod = (canMorning && canAfternoon)
        ? quotaPeriod
        : (!canMorning && canAfternoon ? "afternoon" : "morning");

      if (currentPeriod === "morning") {
        if (CheckInTime < "08:00") {
          errors.push("ช่วงเช้าสามารถลงเวลาได้ตั้งแต่ 08:00 น. เป็นต้นไป");
        }
        if (CheckInTime >= "13:00") {
          errors.push("ช่วงเช้าต้องเริ่มก่อน 13:00 น.");
        }
      } else if (currentPeriod === "afternoon") {
        if (CheckInTime < "13:00") {
          errors.push("ช่วงบ่ายสามารถลงเวลาได้ตั้งแต่ 13:00 น. เป็นต้นไป");
        }
      }
    }

    if (errors.length > 0) {
      setErrMsg(errors);
      setModalError(true);
      return;
    }

    setModalConfirm(true);
  };

  const handleConfirmSave = () => {
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    // คำนวณ CheckInDT และ CheckOutDT โดยนำ วันที่มาปฏิบัติงาน + เวลา (Local GMT+7 format)
    let checkInDT = null;
    let checkOutDT = null;

    if (AttendanceType === 1 || AttendanceType === 3 || AttendanceType === 10) {
      checkInDT = moment(`${WorkDate} ${CheckInTime}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DDTHH:mm:ss");
    }
    if (AttendanceType === 2 || AttendanceType === 3 || AttendanceType === 10) {
      checkOutDT = moment(`${WorkDate} ${CheckOutTime}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DDTHH:mm:ss");
    }

    const isDisableLv1 = Boolean(selectedCategory?.isDisableLv1);

    const payload = {
      workDate: moment(WorkDate).format("YYYY-MM-DDT00:00:00"),
      categoryID: selectedCategoryID,
      attendanceType: selectedCategory ? selectedCategory.categoryMode : AttendanceType,
      durationHours: selectedCategory?.categoryMode === 10 ? DurationHours : null,
      checkInDT: checkInDT,
      checkOutDT: checkOutDT,
      reason: Reason,
      witnessUserName: isDisableLv1 ? null : (WitnessUserName || null),
      departmentBossUserName: (departmentBossList.length > 0 && DepartmentBossUserName) ? DepartmentBossUserName : null,
      groupWorkBossUserName: (groupWorkBossList.length > 0 && GroupWorkBossUserName) ? GroupWorkBossUserName : null,
      missionBossUserName: (missionBossList.length > 0 && MissionBossUserName) ? MissionBossUserName : null,
      bossUserName: DepartmentBossUserName || GroupWorkBossUserName || MissionBossUserName || BossUserName || null,
      hrUserName: HRUserName,
    };

    axios
      .post("/api/v1/timeattendance", payload)
      .then((res) => {
        setIcon("far fa-question-circle");
        setModalConfirm(false);
        if (res.data?.result === 200) {
          setTimeAttendanceRequestID(res.data.data.timeAttendanceRequestID);
          setModalSuccess(true);
        } else {
          setErrMsg([res.data?.msg || "เกิดข้อผิดพลาดในการบันทึก"]);
          setModalError(true);
        }
      })
      .catch((err) => {
        setIcon("far fa-question-circle");
        setModalConfirm(false);
        setErrMsg(["เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์"]);
        setModalError(true);
      });
  };

  const handleOpenApproveModal = (approveKey, isApproveVal, defaultDesc) => {
    setSelectedApproveKey(approveKey);
    setActionIsApprove(isApproveVal);
    setApproveDescription(defaultDesc);
    setModalApprove(true);
  };

  const handleConfirmApprove = () => {
    if (!selectedApproveKey) return;
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    const payload = {
      isApprove: actionIsApprove,
      approveDescription: approveDescription,
    };

    axios
      .put(`/api/v1/timeattendance/approve/${selectedApproveKey}`, payload)
      .then((res) => {
        setIcon("far fa-question-circle");
        setModalApprove(false);
        if (res.data?.result === 200) {
          setModalSuccess(true);
        } else {
          setErrMsg([res.data?.msg || "ไม่สามารถบันทึกการอนุมัติได้"]);
          setModalError(true);
        }
      })
      .catch((err) => {
        setIcon("far fa-question-circle");
        setModalApprove(false);
        setErrMsg(["เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์"]);
        setModalError(true);
      });
  };

  const handleCancelRequest = () => {
    if (!TimeAttendanceRequestID) return;
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    axios
      .put(`/api/v1/timeattendance/cancel/${TimeAttendanceRequestID}`)
      .then((res) => {
        setIcon("far fa-question-circle");
        setModalCancel(false);
        if (res.data?.result === 200) {
          setIsCancel(true);
          setModalSuccess(true);
        } else {
          setErrMsg([res.data?.msg || "ไม่สามารถยกเลิกได้"]);
          setModalError(true);
        }
      })
      .catch((err) => {
        setIcon("far fa-question-circle");
        setModalCancel(false);
        setErrMsg(["เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์"]);
        setModalError(true);
      });
  };

  const handleCloseSuccess = () => {
    setModalSuccess(false);
    const basePath = location.pathname.startsWith("/leave") ? "/leave/attendance" : "/hr/attendance";
    if (TimeAttendanceRequestID) {
      history.push(`${basePath}/request/${TimeAttendanceRequestID}`);
      window.location.reload();
    } else {
      history.push(`${basePath}/me`);
    }
  };

  return (
    <div>
      <Grid>
        <Col xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>
                ระบบลงเวลาปฏิบัติราชการ (ลงเวลาย้อนหลัง / ขออนุญาตตามโควต้า)
              </h4>
              <p className={classes.cardCategoryWhite}>
                กรุณาระบุรายละเอียดการลงเวลา พยานร่วมรับรอง และผู้บังคับบัญชา
              </p>
            </CardHeader>

            <CardBody>
              {/* แถบแจ้งสถานะยกเลิก */}
              {IsCancel && (
                <Grid>
                  <Col xs={12} sm={12} md={12} style={{ background: "#f44336", borderRadius: "4px", padding: "10px", marginBottom: "15px" }}>
                    <h4 style={{ color: "white", textAlign: "center", margin: 0 }}>
                      <i className="fa fa-ban mr-2"></i> คำขอนี้ถูกยกเลิกแล้ว
                    </h4>
                  </Col>
                </Grid>
              )}

              {/* ข้อมูลผู้ขอ (กรณีโหมดดูข้อมูล) */}
              {isEdit && RequesterName && (
                <Grid style={{ marginBottom: "15px" }}>
                  <Col xs={12} sm={12} md={12}>
                    <div style={{ background: "#f8f9fa", borderLeft: "4px solid #9c27b0", padding: "12px 16px", borderRadius: "4px" }}>
                      <Typography variant="subtitle1" style={{ fontWeight: "bold", color: "#333" }}>
                        <i className="fa fa-user mr-2 text-primary"></i> ผู้ขอลงเวลา: {RequesterName}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {RequesterInfo}
                      </Typography>
                    </div>
                  </Col>
                </Grid>
              )}

              {/* ข้อมูลประเภทการลงเวลา (กรณีโหมดดูข้อมูล) */}
              {isEdit && (
                <Grid style={{ marginBottom: "15px" }}>
                  <Col xs={12} sm={12} md={12}>
                    <div style={{ background: "#e8eaf6", borderLeft: "4px solid #3f51b5", padding: "12px 16px", borderRadius: "4px" }}>
                      <Typography variant="subtitle1" style={{ fontWeight: "bold", color: "#1a237e" }}>
                        <i className="fa fa-tag mr-2"></i> ประเภทการลงเวลา: {selectedCategory?.categoryName || (AttendanceType === 1 ? "ลงเวลาเข้างาน (กจ. 1)" : AttendanceType === 2 ? "ลงเวลาออกงาน (กจ. 4)" : AttendanceType === 3 ? "ลืมทั้งเข้าและออกงาน" : "ขอตามโควต้า")}
                      </Typography>
                      {(selectedCategory?.categoryMode === 10 || AttendanceType === 10) && (
                        <Typography variant="body2" style={{ color: "#283593", marginTop: "4px", fontWeight: "bold" }}>
                          ระยะเวลาที่ขอ: {DurationHours > 0 ? DurationHours : calculateDuration(CheckInTime, CheckOutTime)} ชั่วโมง ({CheckInTime} - {CheckOutTime} น.)
                        </Typography>
                      )}
                    </div>
                  </Col>
                </Grid>
              )}

              {/* 1. วันที่มาปฏิบัติงาน และ ประเภทการลงเวลา */}
              <Grid>
                <Col xs={12} sm={6} md={6}>
                  <Label style={{ fontWeight: "bold" }}>
                    วันที่มาปฏิบัติงาน <span style={{ color: "red" }}>*</span>
                  </Label>
                  <FormGroup style={{ marginBottom: "15px" }}>
                    <Datetime
                      value={moment(WorkDate).isValid() ? moment(WorkDate) : null}
                      dateFormat="D MMMM BBBB"
                      timeFormat={false}
                      closeOnSelect={true}
                      inputProps={{
                        name: "WorkDate",
                        placeholder: "เลือกวันที่มาปฏิบัติงาน",
                        readOnly: "readonly",
                        disabled: isEdit,
                        style: {
                          fontSize: "1.1em",
                          borderRadius: 0,
                          padding: "10px",
                          cursor: isEdit ? "not-allowed" : "pointer",
                          background: isEdit ? "#e9ecef" : "#ffffff",
                        },
                        value: moment(WorkDate).isValid() ? moment(WorkDate).format("D MMMM BBBB") : "",
                      }}
                      onChange={handleWorkDateChange}
                    />
                  </FormGroup>
                </Col>

                {/* 2. ตัวเลือกประเภทการลงเวลา (Dropdown จาก DB) */}
                <Col xs={12} sm={6} md={6}>
                  <TSSelect2
                    label="ประเภท / หมวดหมู่การลงเวลา"
                    options={categories.map((c) => ({
                      value: c.categoryID,
                      label: `${c.categoryName}${
                        c.categoryMode === 10 && c.maxHoursPerRequest
                          ? ` (${c.maxHoursPerRequest} ชม./ครั้ง${
                              c.allowMorning && !c.allowAfternoon
                                ? ", เช้า"
                                : !c.allowMorning && c.allowAfternoon
                                ? ", บ่าย"
                                : ""
                            })`
                          : ""
                      }`,
                    }))}
                    value={selectedCategoryID}
                    isDisabled={isEdit}
                    onChange={(e) => handleCategoryChange(e ? e.value : null)}
                  />
                </Col>
              </Grid>

              {/* การแสดงสถิติและโควต้าคงเหลือ (สำหรับหมวดขอตามโควต้า) */}
              {(selectedCategory?.categoryMode === 10 || AttendanceType === 10) && (
                <Grid style={{ marginBottom: "15px" }}>
                  <Col xs={12} sm={12} md={12}>
                    <div
                      style={{
                        background: quotaInfo?.hasQuota !== false ? "#f1f8e9" : "#ffebee",
                        border: `1px solid ${quotaInfo?.hasQuota !== false ? "#c8e6c9" : "#ffcdd2"}`,
                        borderRadius: "6px",
                        padding: "16px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: "10px",
                        }}
                      >
                        <div>
                          <Typography
                            variant="subtitle1"
                            style={{
                              fontWeight: "bold",
                              color: quotaInfo?.hasQuota !== false ? "#2e7d32" : "#c62828",
                            }}
                          >
                            <i className="fa fa-chart-pie mr-2"></i>
                            สถิติและโควต้า: {selectedCategory?.categoryName || "หมวดขอตามโควต้า"}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            รอบการคำนวณ: <strong>{quotaInfo?.periodName || (loadingQuota ? "กำลังตรวจสอบ..." : "ไม่จำกัดรอบ")}</strong>
                          </Typography>
                        </div>
                        <div>
                          {quotaInfo && quotaInfo.quotaLimitType > 0 ? (
                            <Chip
                              label={
                                quotaInfo.remainingQuota > 0
                                  ? `คงเหลือ ${quotaInfo.remainingQuota} ครั้ง`
                                  : "โควต้าเต็มแล้ว"
                              }
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                backgroundColor: quotaInfo.remainingQuota > 0 ? "#4caf50" : "#f44336",
                                color: "#fff",
                              }}
                            />
                          ) : (
                            <Chip
                              label="ไม่จำกัดโควต้า"
                              style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                backgroundColor: "#1976d2",
                                color: "#fff",
                              }}
                            />
                          )}
                        </div>
                      </div>

                      {quotaInfo && (
                        <div style={{ display: "flex", gap: "25px", marginTop: "12px", flexWrap: "wrap" }}>
                          <div>
                            <small style={{ color: "#666" }}>สิทธิ์ที่ได้รับ:</small>
                            <div style={{ fontWeight: "bold", color: "#333" }}>
                              {quotaInfo.quotaLimitType > 0
                                ? `${quotaInfo.quotaMaxCount} ครั้ง (${quotaInfo.quotaLimitTypeName})`
                                : "ไม่จำกัดความถี่"}
                            </div>
                          </div>
                          <div>
                            <small style={{ color: "#666" }}>ใช้ไปแล้วในรอบนี้:</small>
                            <div style={{ fontWeight: "bold", color: "#1976d2" }}>
                              {quotaInfo.usedCount} ครั้ง (อนุมัติ {quotaInfo.approvedCount}, รอผล {quotaInfo.pendingCount})
                            </div>
                          </div>
                          <div>
                            <small style={{ color: "#666" }}>สิทธิ์ชั่วโมงต่อครั้ง:</small>
                            <div style={{ fontWeight: "bold", color: "#e65100" }}>
                              {selectedCategory?.maxHoursPerRequest
                                ? `ไม่เกิน ${selectedCategory.maxHoursPerRequest} ชม./ครั้ง`
                                : "ไม่จำกัด"}
                            </div>
                          </div>
                          <div>
                            <small style={{ color: "#666" }}>ช่วงเวลาที่อนุญาต:</small>
                            <div style={{ fontWeight: "bold", color: "#2e7d32" }}>
                              {selectedCategory?.allowMorning !== false && selectedCategory?.allowAfternoon !== false
                                ? "ช่วงเช้า & ช่วงบ่าย"
                                : selectedCategory?.allowMorning !== false
                                ? "เฉพาะช่วงเช้า (08:00+)"
                                : "เฉพาะช่วงบ่าย (13:00+)"}
                            </div>
                          </div>
                        </div>
                      )}

                      {selectedCategory?.description && (
                        <div
                          style={{
                            marginTop: "10px",
                            fontSize: "13px",
                            color: "#555",
                            borderTop: "1px dashed #ccc",
                            paddingTop: "8px",
                          }}
                        >
                          <i className="fa fa-info-circle mr-1 text-info"></i> คำชี้แจง: {selectedCategory.description}
                        </div>
                      )}

                      {quotaInfo && quotaInfo.quotaLimitType > 0 && quotaInfo.remainingQuota <= 0 && !isEdit && (
                        <div
                          style={{
                            marginTop: "12px",
                            padding: "8px 12px",
                            background: "#f44336",
                            color: "#fff",
                            borderRadius: "4px",
                            fontSize: "14px",
                            fontWeight: "bold",
                          }}
                        >
                          <i className="fa fa-exclamation-triangle mr-2"></i>
                          ขออภัย โควต้าของคุณในรอบนี้เต็มแล้ว ({quotaInfo.usedCount}/{quotaInfo.quotaMaxCount} ครั้ง) ไม่สามารถยื่นคำขอเพิ่มได้
                        </div>
                      )}
                    </div>
                  </Col>
                </Grid>
              )}

              {/* 3. เวลาเข้างาน / ออกงาน หรือ ช่วงเวลาขอออกไป (Mode 10) */}
              {(selectedCategory?.categoryMode === 10 || AttendanceType === 10) ? (
                <Grid>
                  {/* ตัวเลือกช่วงเวลา (กรณีอนุญาตทั้ง 2 ช่วง) หรือแถบข้อความแจ้งเตือน (กรณี fix ช่วงเดียว) */}
                  {(() => {
                    const canM = selectedCategory ? (selectedCategory.allowMorning !== false) : true;
                    const canA = selectedCategory ? (selectedCategory.allowAfternoon !== false) : true;

                    if (canM && canA) {
                      return (
                        <Col xs={12} sm={12} md={12} style={{ marginBottom: "12px" }}>
                          <Label style={{ fontWeight: "bold" }}>
                            เลือกช่วงเวลาที่ต้องการขอ <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            type="select"
                            value={quotaPeriod}
                            disabled={isEdit}
                            onChange={(e) => handlePeriodChange(e.target.value)}
                            style={{ fontSize: "1.05em", height: "42px", fontWeight: "500", maxWidth: "420px" }}
                          >
                            <option value="morning">🌅 ช่วงเช้า (เริ่ม 08:00 น. เป็นต้นไป)</option>
                            <option value="afternoon">🌇 ช่วงบ่าย (เริ่ม 13:00 น. เป็นต้นไป)</option>
                          </Input>
                        </Col>
                      );
                    } else if (canM && !canA) {
                      return (
                        <Col xs={12} sm={12} md={12} style={{ marginBottom: "12px" }}>
                          <div style={{ backgroundColor: "#fff8e1", border: "1px solid #ffe082", borderRadius: "4px", padding: "8px 14px", color: "#f57f17", fontSize: "14px", fontWeight: "500" }}>
                            <i className="fa fa-info-circle mr-2"></i>
                            หมวดหมู่นี้กำหนดให้ขอได้เฉพาะ <strong>ช่วงเช้า</strong> (เริ่มลงเวลาได้ตั้งแต่ 08:00 น. เป็นต้นไป)
                          </div>
                        </Col>
                      );
                    } else if (!canM && canA) {
                      return (
                        <Col xs={12} sm={12} md={12} style={{ marginBottom: "12px" }}>
                          <div style={{ backgroundColor: "#ede7f6", border: "1px solid #d1c4e9", borderRadius: "4px", padding: "8px 14px", color: "#512da8", fontSize: "14px", fontWeight: "500" }}>
                            <i className="fa fa-info-circle mr-2"></i>
                            หมวดหมู่นี้กำหนดให้ขอได้เฉพาะ <strong>ช่วงบ่าย</strong> (เริ่มลงเวลาได้ตั้งแต่ 13:00 น. เป็นต้นไป)
                          </div>
                        </Col>
                      );
                    }
                    return null;
                  })()}

                  <Col xs={12} sm={6} md={6}>
                    <Label style={{ fontWeight: "bold" }}>
                      ตั้งแต่เวลา <span style={{ color: "red" }}>*</span>
                      <small style={{ color: "#666", fontWeight: "normal", marginLeft: "6px" }}>
                        {quotaPeriod === "afternoon" || (selectedCategory?.allowMorning === false && selectedCategory?.allowAfternoon !== false)
                          ? "(เริ่มตั้งแต่ 13:00 น. เป็นต้นไป)"
                          : "(เริ่มตั้งแต่ 08:00 น. เป็นต้นไป)"}
                      </small>
                    </Label>
                    <Input
                      type="time"
                      value={CheckInTime}
                      min={quotaPeriod === "afternoon" || (selectedCategory?.allowMorning === false && selectedCategory?.allowAfternoon !== false) ? "13:00" : "08:00"}
                      disabled={isEdit}
                      onChange={(e) => {
                        setCheckInTime(e.target.value);
                        const dur = calculateDuration(e.target.value, CheckOutTime);
                        setDurationHours(dur);
                      }}
                      style={{ fontSize: "1.1em", height: "42px" }}
                    />
                  </Col>
                  <Col xs={12} sm={6} md={6}>
                    <Label style={{ fontWeight: "bold" }}>
                      ถึงเวลา <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Input
                      type="time"
                      value={CheckOutTime}
                      disabled={isEdit}
                      onChange={(e) => {
                        setCheckOutTime(e.target.value);
                        const dur = calculateDuration(CheckInTime, e.target.value);
                        setDurationHours(dur);
                      }}
                      style={{ fontSize: "1.1em", height: "42px" }}
                    />
                  </Col>
                  <Col xs={12} sm={12} md={12} style={{ marginTop: "8px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
                      <Typography variant="body1">
                        รวมระยะเวลาที่ขอ:{" "}
                        <strong style={{ color: "#1976d2", fontSize: "18px" }}>
                          {DurationHours > 0 ? DurationHours : calculateDuration(CheckInTime, CheckOutTime)}
                        </strong>{" "}
                        ชั่วโมง
                      </Typography>
                      {selectedCategory?.maxHoursPerRequest && DurationHours > selectedCategory.maxHoursPerRequest && (
                        <span style={{ color: "#d32f2f", fontWeight: "bold", fontSize: "14px" }}>
                          <i className="fa fa-exclamation-circle mr-1"></i> เกินสิทธิ์สูงสุดที่กำหนด ({selectedCategory.maxHoursPerRequest} ชม./ครั้ง)
                        </span>
                      )}
                    </div>
                  </Col>
                </Grid>
              ) : (
                <Grid>
                  {(AttendanceType === 1 || AttendanceType === 3) && (
                    <Col xs={12} sm={6} md={6}>
                      <Label style={{ fontWeight: "bold" }}>
                        เวลาเข้าปฏิบัติงานจริง <span style={{ color: "red" }}>*</span>
                      </Label>
                      <Input
                        type="time"
                        value={CheckInTime}
                        disabled={isEdit}
                        onChange={(e) => setCheckInTime(e.target.value)}
                        style={{ fontSize: "1.1em", height: "42px" }}
                      />
                    </Col>
                  )}

                  {(AttendanceType === 2 || AttendanceType === 3) && (
                    <Col xs={12} sm={6} md={6}>
                      <Label style={{ fontWeight: "bold" }}>
                        เวลาออกปฏิบัติงานจริง <span style={{ color: "red" }}>*</span>
                      </Label>
                      <Input
                        type="time"
                        value={CheckOutTime}
                        disabled={isEdit}
                        onChange={(e) => setCheckOutTime(e.target.value)}
                        style={{ fontSize: "1.1em", height: "42px" }}
                      />
                    </Col>
                  )}
                </Grid>
              )}

              {/* 4. เหตุผล / วัตถุประสงค์ */}
              <Grid style={{ marginTop: "15px" }}>
                <Col xs={12} sm={12} md={12}>
                  <Label style={{ fontWeight: "bold" }}>
                    {selectedCategory?.categoryMode === 10
                      ? "เหตุผล / วัตถุประสงค์ในการขออนุญาต"
                      : "เหตุผลที่ไม่ได้สแกนลายนิ้วมือเข้าปฏิบัติงาน / ไม่ได้ลงนามในเวลาที่กำหนด"}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    type="textarea"
                    rows="3"
                    placeholder={
                      selectedCategory?.categoryMode === 10
                        ? "เช่น ไปตรวจสุขภาพประจำปี, ใช้บริการแพทย์แผนไทย, ติดต่อราชการ ฯลฯ"
                        : "เช่น ไปราชการเร่งด่วน, เครื่องสแกนขัดข้อง, ลืมสแกนลายนิ้วมือ ฯลฯ"
                    }
                    value={Reason}
                    disabled={isEdit}
                    onChange={(e) => setReason(e.target.value)}
                    style={{ fontSize: "1.1em" }}
                  />
                </Col>
              </Grid>

              {/* 5. สายการอนุมัติ (Flow: 1.Lv1Text / ผู้รับงานแทน -> 2.หัวหน้างาน -> 3.หัวหน้ากลุ่มงาน -> 4.รองภารกิจ) */}
              <Grid style={{ marginTop: "15px" }}>
                {/* 1. ตาม lv1Text (ผู้รับงานแทน เปรียบเสมือน WitnessUserName) */}
                {!selectedCategory?.isDisableLv1 && (
                  <Col xs={12} sm={6} md={6} style={{ marginBottom: "15px" }}>
                    <TSSelect2
                      isClearable={true}
                      zIndex={7}
                      label={selectedCategory?.lv1Text || "พยาน (เจ้าหน้าที่ร่วมรับรอง)"}
                      options={witnessList}
                      value={WitnessUserName}
                      isDisabled={isEdit}
                      onChange={(e) => setWitnessUserName(e ? e.value : "")}
                    />
                  </Col>
                )}

                {/* 2. หัวหน้างาน */}
                {departmentBossList.length > 0 && (
                  <Col xs={12} sm={6} md={6} style={{ marginBottom: "15px" }}>
                    <TSSelect2
                      isClearable={true}
                      zIndex={6}
                      label="หัวหน้างาน"
                      options={departmentBossList}
                      value={DepartmentBossUserName}
                      isDisabled={isEdit}
                      onChange={(e) => setDepartmentBossUserName(e ? e.value : "")}
                    />
                  </Col>
                )}

                {/* 3. หัวหน้ากลุ่มงาน */}
                {groupWorkBossList.length > 0 && (
                  <Col xs={12} sm={6} md={6} style={{ marginBottom: "15px" }}>
                    <TSSelect2
                      isClearable={true}
                      zIndex={5}
                      label="หัวหน้ากลุ่มงาน"
                      options={groupWorkBossList}
                      value={GroupWorkBossUserName}
                      isDisabled={isEdit}
                      onChange={(e) => setGroupWorkBossUserName(e ? e.value : "")}
                    />
                  </Col>
                )}

                {/* 4. รองภารกิจ */}
                {missionBossList.length > 0 && (
                  <Col xs={12} sm={6} md={6} style={{ marginBottom: "15px" }}>
                    <TSSelect2
                      isClearable={true}
                      zIndex={4}
                      label="รองภารกิจ"
                      options={missionBossList}
                      value={MissionBossUserName}
                      isDisabled={isEdit}
                      onChange={(e) => setMissionBossUserName(e ? e.value : "")}
                    />
                  </Col>
                )}

                {/* กรณี fallback: หาก activeUserLevel < 4 แต่ไม่มีหัวหน้าระดับ 2-4 ใน MyTeam ให้แสดงผู้บังคับบัญชาทั่วไป */}
                {activeUserLevel < 4 && !departmentBossList.length && !groupWorkBossList.length && !missionBossList.length && bossList.length > 0 && (
                  <Col xs={12} sm={6} md={6} style={{ marginBottom: "15px" }}>
                    <TSSelect2
                      isClearable={true}
                      zIndex={3}
                      label="หัวหน้าอนุมัติ (ผู้บังคับบัญชา)"
                      options={bossList}
                      value={BossUserName}
                      isDisabled={isEdit}
                      onChange={(e) => setBossUserName(e ? e.value : "")}
                    />
                  </Col>
                )}
              </Grid>

              {/* Action Buttons (บันทึก / ยกเลิกคำขอ) */}
              <Grid style={{ marginTop: "25px" }}>
                {!isEdit && (
                  <Col xs={12} sm={6} md={4}>
                    <Button color="info" fullWidth onClick={handleSubmit}>
                      <i className="fa fa-save mr-2"></i> บันทึกและส่งขออนุมัติ
                    </Button>
                  </Col>
                )}

                {isEdit && !IsCancel && RequestStatusKey !== 2 && (currentUser?.userName === currentUser?.userName || isHR) && (
                  <Col xs={12} sm={6} md={4}>
                    <Button color="danger" fullWidth onClick={() => setModalCancel(true)}>
                      <i className="fa fa-times mr-2"></i> ยกเลิกคำขอนี้
                    </Button>
                  </Col>
                )}
              </Grid>
            </CardBody>
          </Card>

          {/* Timeline ติดตามสถานะการอนุมัติ */}
          {isEdit && Approvals && Approvals.length > 0 && (
            <Card style={{ marginTop: "20px" }}>
              <CardHeader color="info">
                <h4 className={classes.cardTitleWhite}>
                  <i className="fa fa-history mr-2"></i> ติดตามสถานะการรับรองและอนุมัติ ({Approvals.length} ขั้นตอน)
                </h4>
              </CardHeader>
              <CardBody>
                <Timeline align="alternate">
                  {Approvals.map((item, idx) => {
                    const isDisableLv1 = Boolean(selectedCategory?.isDisableLv1);
                    const uName = item.approveUserName?.toLowerCase();
                    const isLv1Step = !isDisableLv1 && (uName === WitnessUserName?.toLowerCase() || (item.stepOrder === 1 && Boolean(WitnessUserName)));

                    let stepName = "";
                    if (isLv1Step) {
                      stepName = `${item.stepOrder}. ${selectedCategory?.lv1Text || "พยานรับรอง"}`;
                    } else if (uName === DepartmentBossUserName?.toLowerCase()) {
                      stepName = `${item.stepOrder}. หัวหน้างานเห็นชอบ`;
                    } else if (uName === GroupWorkBossUserName?.toLowerCase()) {
                      stepName = `${item.stepOrder}. หัวหน้ากลุ่มงานเห็นชอบ`;
                    } else if (uName === MissionBossUserName?.toLowerCase()) {
                      stepName = `${item.stepOrder}. รองภารกิจอนุมัติ`;
                    } else if (item.stepOrder === Approvals.length) {
                      stepName = `${item.stepOrder}. หัวหน้างานฝ่ายทรัพยากรบุคคลอนุมัติ`;
                    } else {
                      stepName = `${item.stepOrder}. ผู้พิจารณาอนุมัติ`;
                    }

                    let statusText = "รอคิว";
                    let statusColor = "#9e9e9e";
                    let dotColor = "grey";

                    if (item.approveStatusKey === 1) {
                      statusText = "รอดำเนินการ (ถึงคิว)";
                      statusColor = "#ff9800";
                      dotColor = "secondary";
                    } else if (item.approveStatusKey === 2) {
                      statusText = "รับรอง / อนุมัติแล้ว";
                      statusColor = "#4caf50";
                      dotColor = "primary";
                    } else if (item.approveStatusKey === -1) {
                      statusText = "ไม่รับรอง / ปฏิเสธ";
                      statusColor = "#f44336";
                      dotColor = "secondary";
                    }

                    const canCurrentApprove =
                      item.approveStatusKey === 1 &&
                      (currentUser?.userName?.toLowerCase() === item.approveUserName?.toLowerCase() || isHR);

                    return (
                      <TimelineItem key={idx}>
                        <TimelineOppositeContent>
                          <Typography style={{ color: statusColor, fontWeight: "bold" }}>
                            {statusText}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            {item.approveDT ? moment(item.approveDT).format("D MMM BB HH:mm น.") : ""}
                          </Typography>
                        </TimelineOppositeContent>

                        <TimelineSeparator>
                          <TimelineDot color={dotColor} variant="outlined">
                            <Avatar
                              alt={item.approveUserName}
                              src={`https://e.trangskin.go.th/avatar/${item.approveUserName}.jpg`}
                              className={classes.largeAvatar}
                            />
                          </TimelineDot>
                          {idx < Approvals.length - 1 && <TimelineConnector />}
                        </TimelineSeparator>

                        <TimelineContent>
                          <Paper elevation={3} className={classes.paper}>
                            <Typography variant="subtitle2" style={{ fontWeight: "bold", color: "#9c27b0" }}>
                              {stepName}
                            </Typography>
                            <Typography variant="body2">
                              {item.userView ? `${item.userView.firstName} ${item.userView.lastName}` : item.approveUserName}
                            </Typography>

                            {item.approveDescription && (
                              <Typography variant="body2" style={{ fontStyle: "italic", color: "#555", marginTop: "4px" }}>
                                "{item.approveDescription}"
                              </Typography>
                            )}

                            {/* ปุ่มสำหรับผู้อนุมัติขั้นนั้นๆ */}
                            {canCurrentApprove && (
                              <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                                <Button
                                  color="success"
                                  size="sm"
                                  onClick={() =>
                                    handleOpenApproveModal(
                                      item.approveSystemKey,
                                      true,
                                      isLv1Step ? "รับรองการมาปฏิบัติงานจริง" : "เห็นควรอนุมัติ"
                                    )
                                  }
                                >
                                  <i className="fa fa-check mr-1"></i> {isLv1Step ? "รับรอง" : "อนุมัติ"}
                                </Button>
                                <Button
                                  color="danger"
                                  size="sm"
                                  onClick={() =>
                                    handleOpenApproveModal(
                                      item.approveSystemKey,
                                      false,
                                      isLv1Step ? "ไม่รับรอง" : "ไม่อนุมัติ"
                                    )
                                  }
                                >
                                  <i className="fa fa-times mr-1"></i> {isLv1Step ? "ไม่รับรอง" : "ไม่อนุมัติ"}
                                </Button>
                              </div>
                            )}
                          </Paper>
                        </TimelineContent>
                      </TimelineItem>
                    );
                  })}
                </Timeline>
              </CardBody>
            </Card>
          )}

          {/* Modal ยืนยันการบันทึกคำขอ */}
          <Modal isOpen={modalConfirm} toggle={() => setModalConfirm(false)}>
            <div className="modal-header justify-content-center">
              <i className={icon} style={{ color: "#00acc1", fontSize: "2.5em" }}></i>
            </div>
            <ModalBody style={{ textAlign: "center", fontSize: "1.2em" }}>
              ยืนยันการบันทึกขอลงเวลาปฏิบัติราชการ และส่งไปยังพยานเพื่อรับรอง?
            </ModalBody>
            <div className="modal-footer justify-content-center">
              <Button color="info" onClick={handleConfirmSave}>
                <i className="fa fa-check mr-2"></i> ยืนยัน
              </Button>
              <Button color="danger" onClick={() => setModalConfirm(false)}>
                ยกเลิก
              </Button>
            </div>
          </Modal>

          {/* Modal อนุมัติ / รับรอง */}
          <Modal isOpen={modalApprove} toggle={() => setModalApprove(false)}>
            <div className="modal-header justify-content-center">
              <h5 style={{ fontWeight: "bold" }}>
                {actionIsApprove ? "ยืนยันการรับรอง / อนุมัติ" : "ยืนยันการปฏิเสธคำขอ"}
              </h5>
            </div>
            <ModalBody>
              <Label>ระบุความเห็น / หมายเหตุ:</Label>
              <Input
                type="textarea"
                rows="3"
                value={approveDescription}
                onChange={(e) => setApproveDescription(e.target.value)}
              />
            </ModalBody>
            <div className="modal-footer justify-content-center">
              <Button color={actionIsApprove ? "success" : "danger"} onClick={handleConfirmApprove}>
                <i className="fa fa-check mr-2"></i> ยืนยัน
              </Button>
              <Button color="secondary" onClick={() => setModalApprove(false)}>
                ยกเลิก
              </Button>
            </div>
          </Modal>

          {/* Modal ยกเลิกคำขอ */}
          <Modal isOpen={modalCancel} toggle={() => setModalCancel(false)}>
            <div className="modal-header justify-content-center">
              <i className="fa fa-exclamation-triangle text-danger" style={{ fontSize: "2.5em" }}></i>
            </div>
            <ModalBody style={{ textAlign: "center", fontSize: "1.2em" }}>
              คุณแน่ใจหรือไม่ว่าต้องการยกเลิกคำขอลงเวลานี้?
            </ModalBody>
            <div className="modal-footer justify-content-center">
              <Button color="danger" onClick={handleCancelRequest}>
                <i className="fa fa-trash mr-2"></i> ยืนยันยกเลิก
              </Button>
              <Button color="secondary" onClick={() => setModalCancel(false)}>
                ปิด
              </Button>
            </div>
          </Modal>

          {/* Modal สำเร็จ */}
          <Modal isOpen={modalSuccess} toggle={handleCloseSuccess}>
            <div className="modal-header justify-content-center">
              <i className="fa fa-check-circle text-success" style={{ fontSize: "3.5em" }}></i>
            </div>
            <ModalBody style={{ textAlign: "center", fontSize: "1.4em" }}>
              บันทึกข้อมูลสำเร็จเรียบร้อยแล้ว
            </ModalBody>
            <div className="modal-footer justify-content-center">
              <Button color="info" onClick={handleCloseSuccess}>
                ตกลง
              </Button>
            </div>
          </Modal>

          {/* Modal ข้อผิดพลาด */}
          <Modal isOpen={modalError} toggle={() => setModalError(false)}>
            <div className="modal-header justify-content-center">
              <i className="fa fa-times-circle text-danger" style={{ fontSize: "3em" }}></i>
            </div>
            <ModalBody>
              <h5 style={{ textAlign: "center", color: "#f44336", fontWeight: "bold" }}>
                ไม่สามารถดำเนินการได้
              </h5>
              <ul>
                {errMsg.map((msg, i) => (
                  <li key={i}>{msg}</li>
                ))}
              </ul>
            </ModalBody>
            <div className="modal-footer justify-content-center">
              <Button color="secondary" onClick={() => setModalError(false)}>
                ปิด
              </Button>
            </div>
          </Modal>
        </Col>
      </Grid>
    </div>
  );
};

export default Request;
